<template>
  <div>
    <div style="margin-top:20px">
      <p style="text-align:center;font-size:16px;margin-top:50px;">采购备货区</p>
      <div v-for="(item, index) in listStockUp" :key="index">
        <el-table
          border
          ref="tableRef"
          :data="item.orderContractStockupVoList"
          max-height="378"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
        >
          <template slot="empty">
            <i class="el-icon-refresh-right" style="padding-right:10px;"></i>
            <span>暂无产品信息</span>
          </template>
          <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
          <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
          <el-table-column show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
          <el-table-column show-overflow-tooltip prop="proType" label="型号">
            <template slot-scope="scope">
              <div
                class="approval line-limit-length"
                @click="onEdit(scope.row)"
              >{{ scope.row.proType }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="orderNumber" label="订货号"></el-table-column>
          <el-table-column prop="cbUnit" label="单位"></el-table-column>
          <el-table-column prop="count" label="备货数量"></el-table-column>
          <el-table-column prop="cbPrice" label="采购单价">
            <template slot-scope="scope">{{ scope.row.cbPrice|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column prop label="采购总额">
            <template slot-scope="scope">{{ (scope.row.count * scope.row.cbPrice)|priceFilterNum}}</template>
          </el-table-column>
          <el-table-column prop="cbPriceSource" label="询价来源">
            <template slot-scope="scope">
              {{
              cbPriceSource[
              scope.row.cbPriceSource - 1
              ]
              }}
            </template>
          </el-table-column>
          <el-table-column prop="suName" show-overflow-tooltip label="询价供应商"></el-table-column>
          <el-table-column prop="cbExtimeValue" label="货期">
            <template slot-scope="scope">
              {{
              scope.row.cbExtimeValue +'天'
              }}
            </template>
          </el-table-column>
          <el-table-column prop="count" label="采购数量" width="120px"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="approval" @click="purchasePlan(scope.row,scope.$index)">撤销</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDate } from '@/util/tool'
export default {
  props: ['listStockUp'],
  components: {
  },
  data () {
    return {
      cbPriceSource: ['系统', '人工', '特价审批', '其他', '库存'] // 询价来源

    }
  },
  watch: {
    allocatedList: {
      handler (newVal) {
        this.allocatedListArray = newVal
      },
      deep: true
    }
  },
  mounted () { },
  methods: {
    onEdit (row) {
      this.$router.push({
        name: 'productDetails',
        query: { id: row.proId }
      })
    },
    purchasePlan (row, index) {
      this.$emit('returnPurchaseList', row, index)
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="scss" scoped>
</style>
